import React from 'react';
import PostCard from './PostCard';

const DayColumn = ({ 
  date, 
  posts,
  holidays = [],
  isToday, 
  onPostClick, 
  onPostEdit, 
  onPostDuplicate, 
  onPostDelete 
}) => {
  const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
  const dayNumber = date.getDate();
  const monthName = date.toLocaleDateString('en-US', { month: 'short' });

  const hasHoliday = holidays.length > 0;
  const isPublicHoliday = holidays.some(h => h.type === 'public');

  return (
    <div className={`flex-1 min-w-[160px] border-r border-gray-200 last:border-r-0 ${
      isToday ? 'bg-indigo-50/30' : hasHoliday ? 'bg-orange-50/20' : ''
    }`}>
      {/* Day Header */}
      <div className={`sticky top-0 z-10 bg-white border-b border-gray-200 p-3 ${
        isToday ? 'bg-indigo-50' : hasHoliday ? 'bg-orange-50/40' : ''
      }`}>
        <div className="text-center">
          <div className="text-xs font-semibold text-gray-500 uppercase mb-1">
            {dayName}
          </div>
          <div className={`inline-flex items-center justify-center w-8 h-8 rounded-full ${
            isToday 
              ? 'bg-indigo-600 text-white font-bold' 
              : isPublicHoliday
              ? 'bg-orange-500 text-white font-bold'
              : 'text-gray-900 font-semibold'
          }`}>
            {dayNumber}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {monthName}
          </div>
        </div>
      </div>

      {/* Day Content with Holidays & Posts */}
      <div className="p-2 min-h-[600px]">
        {/* Display Holidays */}
        {holidays.length > 0 && (
          <div className="mb-3">
            {holidays.map((holiday, idx) => (
              <div 
                key={idx}
                className={`rounded-lg p-2 mb-2 text-xs ${
                  holiday.type === 'public' 
                    ? 'bg-orange-100 border border-orange-300' 
                    : 'bg-amber-50 border border-amber-200'
                }`}
              >
                <div className="flex items-start gap-2">
                  <span className="text-lg leading-none">{holiday.emoji}</span>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-gray-800 leading-tight mb-1">
                      {holiday.name}
                    </div>
                    {holiday.description && (
                      <div className="text-gray-600 text-[10px] leading-tight">
                        {holiday.description}
                      </div>
                    )}
                    <div className="flex items-center gap-1 mt-1">
                      <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${
                        holiday.type === 'public'
                          ? 'bg-orange-200 text-orange-800'
                          : 'bg-amber-200 text-amber-800'
                      }`}>
                        {holiday.category}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Display Scheduled Posts */}
        {posts.length > 0 ? (
          posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              onClick={() => onPostClick(post)}
              onEdit={onPostEdit}
              onDuplicate={onPostDuplicate}
              onDelete={onPostDelete}
            />
          ))
        ) : holidays.length === 0 ? (
          <div className="flex items-center justify-center h-32 text-gray-400 text-sm">
            No posts scheduled
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DayColumn;
